/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SaveApproverRequest model module.
 * @module model/SaveApproverRequest
 * @version V1
 */
class SaveApproverRequest {
    /**
     * Constructs a new <code>SaveApproverRequest</code>.
     * @alias module:model/SaveApproverRequest
     * @param name {String} 
     * @param email {String} 
     * @param frequency {String} 
     * @param timeOfDayToSend {String} 
     * @param timeZone {String} 
     */
    constructor(name, email, frequency, timeOfDayToSend, timeZone) { 
        
        SaveApproverRequest.initialize(this, name, email, frequency, timeOfDayToSend, timeZone);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, email, frequency, timeOfDayToSend, timeZone) { 
        obj['name'] = name;
        obj['email'] = email;
        obj['frequency'] = frequency;
        obj['timeOfDayToSend'] = timeOfDayToSend;
        obj['timeZone'] = timeZone;
    }

    /**
     * Constructs a <code>SaveApproverRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SaveApproverRequest} obj Optional instance to populate.
     * @return {module:model/SaveApproverRequest} The populated <code>SaveApproverRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SaveApproverRequest();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('phone')) {
                obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
            }
            if (data.hasOwnProperty('frequency')) {
                obj['frequency'] = ApiClient.convertToType(data['frequency'], 'String');
            }
            if (data.hasOwnProperty('timeOfDayToSend')) {
                obj['timeOfDayToSend'] = ApiClient.convertToType(data['timeOfDayToSend'], 'String');
            }
            if (data.hasOwnProperty('isNonApprover')) {
                obj['isNonApprover'] = ApiClient.convertToType(data['isNonApprover'], 'Boolean');
            }
            if (data.hasOwnProperty('timeZone')) {
                obj['timeZone'] = ApiClient.convertToType(data['timeZone'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SaveApproverRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SaveApproverRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SaveApproverRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['frequency'] && !(typeof data['frequency'] === 'string' || data['frequency'] instanceof String)) {
            throw new Error("Expected the field `frequency` to be a primitive type in the JSON string but got " + data['frequency']);
        }
        // ensure the json data is a string
        if (data['timeOfDayToSend'] && !(typeof data['timeOfDayToSend'] === 'string' || data['timeOfDayToSend'] instanceof String)) {
            throw new Error("Expected the field `timeOfDayToSend` to be a primitive type in the JSON string but got " + data['timeOfDayToSend']);
        }
        // ensure the json data is a string
        if (data['timeZone'] && !(typeof data['timeZone'] === 'string' || data['timeZone'] instanceof String)) {
            throw new Error("Expected the field `timeZone` to be a primitive type in the JSON string but got " + data['timeZone']);
        }

        return true;
    }


}

SaveApproverRequest.RequiredProperties = ["name", "email", "frequency", "timeOfDayToSend", "timeZone"];

/**
 * @member {String} name
 */
SaveApproverRequest.prototype['name'] = undefined;

/**
 * @member {String} email
 */
SaveApproverRequest.prototype['email'] = undefined;

/**
 * @member {String} phone
 */
SaveApproverRequest.prototype['phone'] = undefined;

/**
 * @member {String} frequency
 */
SaveApproverRequest.prototype['frequency'] = undefined;

/**
 * @member {String} timeOfDayToSend
 */
SaveApproverRequest.prototype['timeOfDayToSend'] = undefined;

/**
 * @member {Boolean} isNonApprover
 */
SaveApproverRequest.prototype['isNonApprover'] = undefined;

/**
 * @member {String} timeZone
 */
SaveApproverRequest.prototype['timeZone'] = undefined;






export default SaveApproverRequest;

